export default "__VITE_ASSET__039a054d__"